(() => {
  const init = () => {
    const elements = document.querySelectorAll('.nv-reveal, .nv-meter');
    if (!elements.length) return;

    const show = (element) => element.classList.add('in-view');
    const reducedMotion = window.matchMedia
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reducedMotion || !('IntersectionObserver' in window)) {
      elements.forEach(show);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        show(entry.target);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.15 });

    elements.forEach((element) => observer.observe(element));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

/* ── Drawn gold hairline ─────────────────────────────────────────────────────
   The one added motion, replacing a scroll-progress bar and a stat count-up that
   the design bench rejected (reasons recorded in CHANGELOG 2026-07-30).

   The theme already paints a 1px gold rule above every charcoal band
   (layout/theme.liquid: `.shopify-section:has(> .color-scheme-3)`). That rule IS
   the brand signature — DESIGN.md defines gold as the jewelry: hairlines, checks,
   stars. So instead of adding a new ornament, this simply draws the existing one
   left-to-right as the band arrives: one calm gesture, once per band, carrying no
   urgency and no data.

   Implemented as an overlay span rather than by animating the border, because a
   border cannot be scaled independently of its element. Fully skipped under
   prefers-reduced-motion, and skipped entirely if :has() is unsupported. */
(() => {
  const init = () => {
    const reduced = window.matchMedia
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || !('IntersectionObserver' in window)) return;
    if (!(CSS && CSS.supports && CSS.supports('selector(:has(*))'))) return;

    const bands = document.querySelectorAll('.shopify-section:has(> .color-scheme-3)');
    if (!bands.length) return;

    const drawn = [];
    bands.forEach((band) => {
      if (band.querySelector(':scope > .nv-rule')) return;
      const rule = document.createElement('span');
      rule.className = 'nv-rule';
      rule.setAttribute('aria-hidden', 'true');
      band.insertBefore(rule, band.firstChild);
      drawn.push(rule);
    });
    if (!drawn.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-drawn');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.01, rootMargin: '0px 0px -10% 0px' });

    drawn.forEach((rule) => observer.observe(rule));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
